import * as React from 'react';

const ShopPage = () => {
  return <div className="coming-soon">Coming soon!</div>;
};

export default ShopPage;
